import { createContext, useContext, useState, useEffect } from "react";

const LanguageContext = createContext(null);

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within LanguageProvider");
  }
  return context;
};

// Translations
const translations = {
  tr: {
    // Navigation
    "nav.login": "GİRİŞ YAP",
    "nav.register": "KAYIT OL",
    "nav.logout": "ÇIKIŞ YAP",
    "nav.dashboard": "PANEL",
    "nav.home": "ANA SAYFA",
    
    // Landing Page
    "hero.title": "BACKLINK PAZARYERI",
    "hero.subtitle": "Yüksek otoriteli sitelerden dofollow backlinkler ile sitenizin SEO performansını artırın.",
    "hero.cta": "HEMEN BAŞLA",
    "hero.stats.sites": "Aktif Site",
    "hero.stats.backlinks": "Backlink",
    "hero.stats.active": "Aktif Link",
    
    // Features
    "features.title": "ÖZELLİKLER",
    "features.subtitle": "Neden ROOT-SEO?",
    
    // Pricing
    "pricing.title": "FİYATLANDIRMA",
    "pricing.subtitle": "Kredi Paketleri",
    "pricing.buy": "SATIN AL",
    "pricing.credits": "Kredi",
    "pricing.bonus": "Bonus Kredi!",
    "pricing.popular": "EN POPÜLER",
    
    // Auth
    "auth.login.title": "Giriş Yap",
    "auth.login.subtitle": "Hesabınıza giriş yapın",
    "auth.login.button": "GİRİŞ YAP",
    "auth.login.noAccount": "Hesabınız yok mu?",
    "auth.register.title": "Kayıt Ol",
    "auth.register.subtitle": "Yeni hesap oluşturun",
    "auth.register.button": "KAYIT OL",
    "auth.register.hasAccount": "Zaten hesabınız var mı?",
    "auth.email": "Email",
    "auth.password": "Şifre",
    "auth.confirmPassword": "Şifre Tekrar",
    "auth.name": "Ad Soyad",
    
    // Dashboard
    "dashboard.welcome": "Hoş Geldiniz",
    "dashboard.credits": "Krediler",
    "dashboard.orders": "Siparişler",
    "dashboard.activeLinks": "Aktif Linkler",
    "dashboard.buyCredits": "KREDİ SATIN AL",
    "dashboard.browseSites": "SİTELERE GÖZ AT",
    "dashboard.recentOrders": "Son Siparişler",
    "dashboard.noOrders": "Henüz sipariş yok",
    "dashboard.viewAll": "Tümünü Gör",
    
    // Site Catalog
    "catalog.title": "Site Kataloğu",
    "catalog.search": "Site ara...",
    "catalog.filter.category": "Kategori",
    "catalog.filter.language": "Dil",
    "catalog.filter.all": "Tümü",
    "catalog.credits": "kredi",
    "catalog.order": "SİPARİŞ VER",
    "catalog.da": "DA",
    "catalog.pa": "PA",
    "catalog.ss": "SS",
    
    // Order Dialog (Customer)
    "order.title": "Sipariş Ver",
    "order.siteInfo": "Site Bilgileri",
    "order.siteName": "Site Adı",
    "order.url": "URL",
    "order.traffic": "TRAFİK",
    "order.baseCost": "Temel Maliyet",
    "order.backlink": "Backlink Siparişi",
    "order.targetUrl": "Hedef URL",
    "order.targetUrlHelp": "Backlink'in yönlendireceği sayfa",
    "order.anchorText": "Anchor Text",
    "order.anchorTextHelp": "Link'te görünecek metin (dofollow, gizli)",
    "order.duration": "Süre",
    "order.currentBalance": "Mevcut Bakiye",
    "order.totalCost": "Toplam Maliyet",
    "order.insufficientCredits": "YETERSİZ KREDİ",
    "order.submit": "SİPARİŞİ ONAYLA",
    "order.success": "Sipariş başarıyla oluşturuldu!",
    "order.linkNote": "Link dofollow olarak, ziyaretçilere görünmeyecek şekilde eklenecektir",
    
    // Credit Packages
    "credits.title": "Kredi Paketleri",
    "credits.subtitle": "İhtiyacınıza uygun paketi seçin",
    "credits.back": "Geri Dön",
    "credits.forBeginners": "Yeni başlayanlar için",
    "credits.forProfessionals": "Profesyoneller için",
    "credits.forEnterprise": "Kurumsal müşteriler için",
    "credits.bonus": "bonus kredi!",
    
    // SEO Services (Customer)
    "seoServices.title": "SEO HİZMETLERİ",
    "seoServices.subtitle": "Gelişmiş SEO araçları ile sitenizin performansını artırın",
    "seoServices.auto": "OTOMATİK",
    "seoServices.manual": "MANUEL",
    "seoServices.insufficientCredits": "YETERSİZ KREDİ",
    "seoServices.orderNow": "SİPARİŞ VER",
    "seoServices.buyCredits": "KREDİ SATIN AL",
    
    // Admin Panel
    "admin.overview": "GENEL BAKIŞ",
    "admin.sites": "SİTELER",
    "admin.orders": "SİPARİŞLER",
    "admin.users": "KULLANICILAR",
    "admin.packages": "KREDİ PAKETLERİ",
    "admin.settings": "AYARLAR",
    "admin.systemSettings": "SİSTEM AYARLARI",
    "admin.systemSettings.warning": "Bu ayarlar sadece Süper Admin tarafından değiştirilebilir. Dikkatli olun!",
    "admin.seoServices": "SEO SERVİSLERİ",
    "admin.totalSites": "Toplam Site",
    "admin.totalOrders": "Siparişler",
    "admin.totalUsers": "Kullanıcılar",
    "admin.revenue": "Gelir",
    "admin.connected": "bağlı",
    "admin.active": "aktif",
    "admin.recentOrders": "Son Siparişler",
    
    // Sites Table Headers
    "admin.table.site": "Site",
    "admin.table.metrics": "Metrikler",
    "admin.table.credit": "Kredi",
    "admin.table.method": "Yöntem",
    "admin.table.connection": "Bağlantı",
    "admin.table.actions": "İşlemler",
    
    // Orders Table Headers
    "admin.table.customer": "Müşteri",
    "admin.table.link": "Link",
    "admin.table.duration": "Süre",
    "admin.table.status": "Durum",
    "admin.table.endDate": "Bitiş",
    
    // Users Table Headers
    "admin.table.name": "Ad",
    "admin.table.email": "Email",
    "admin.table.role": "Rol",
    "admin.table.credits": "Kredi",
    
    // Site Management
    "admin.addSite": "SİTE EKLE",
    "admin.newSite": "YENİ SİTE",
    "admin.editSite": "Site Düzenle",
    "admin.deleteSite": "Site Sil",
    "admin.siteName": "Site Adı",
    "admin.siteUrl": "Site URL",
    "admin.category": "Kategori",
    "admin.language": "Dil",
    "admin.creditCost": "Kredi Maliyeti",
    "admin.linkType": "Link Tipi",
    "admin.placementMethod": "Yerleştirme Yöntemi",
    "admin.placement": "Yerleştirme",
    "admin.traffic": "Trafik",
    "admin.connectionStatus": "Bağlantı Durumu",
    "admin.actions": "İşlemler",
    "admin.connectorUrlFull": "Connector dosyasının tam URL'si",
    "admin.siteKeyCopied": "Site anahtarı kopyalandı",
    
    // User Management
    "admin.userManagement": "Kullanıcı Yönetimi",
    "admin.banUser": "Kullanıcıyı Engelle",
    "admin.unbanUser": "Engeli Kaldır",
    "admin.addCredits": "Kredi Ekle",
    "admin.changeRole": "Rol Değiştir",
    "admin.permissions": "Yetkiler",
    "admin.savePermissions": "YETKİLERİ KAYDET",
    
    // Settings
    "admin.maintenanceMode": "Bakım Modu",
    "admin.maintenanceEnabled": "AKTİF - Site bakımda",
    "admin.maintenanceDisabled": "Kapalı - Site normal çalışıyor",
    "admin.maintenanceWarning": "Bakım modu aktif edildiğinde tüm müşteriler sistemden çıkarılır",
    "admin.stripeSettings": "Stripe Ödeme Ayarları",
    "admin.telegramSettings": "Telegram Bildirim Ayarları",
    "admin.configured": "Yapılandırılmış",
    "admin.notConfigured": "Yapılandırılmamış",
    "admin.save": "KAYDET",
    "admin.test": "Test Et",
    "admin.sendNotification": "Bildirim Gönder",
    "admin.agentCodes": "Agent Kurulum Kodları",
    "admin.themeSettings": "Tema Seçimi",
    "admin.logoSettings": "Logo Seçimi",
    "admin.newPackage": "YENİ PAKET",
    "admin.linkDurations": "Link Süreleri",
    "admin.add": "EKLE",
    "admin.month": "Ay",
    "admin.months": "Ay",
    "admin.year": "Yıl",
    "admin.days": "gün",
    "admin.themeDesc": "Siteniz için bir tema seçin. Temalar uzay, kara delik, aurora ve daha fazlası gibi farklı animasyonlu arka planlar sunar.",
    "admin.logoDesc": "Siteniz için bir logo seçin. Seçilen logo tüm sayfalarda görüntülenir.",
    "admin.siteContentSettings": "Site İçerik Ayarları",
    "admin.footerSettings": "Footer Ayarları",
    "admin.footerText": "Footer Yazısı",
    "admin.telegramLink": "Telegram Kanal Linki",
    "admin.telegramLinkDesc": "Giriş ve ana sayfada görünür",
    "admin.featureCards": "Özellik Kartları (Ana Sayfa)",
    "admin.featureCardsDesc": "Ana sayfada gösterilen 6 özellik kartını düzenleyin",
    "admin.feature": "Özellik",
    "admin.forBeginners": "Yeni başlayanlar için",
    "admin.forProfessionals": "Profesyoneller için",
    "admin.forEnterprises": "Kurumsal müşteriler için",
    "admin.credits": "kredi",
    "admin.bonusCredits": "bonus kredi",
    
    // Theme names
    "admin.theme.default": "Varsayılan",
    "admin.theme.defaultDesc": "Temiz koyu tema",
    "admin.theme.cosmic": "Kozmik",
    "admin.theme.cosmicDesc": "Yıldızlar ve nebula",
    "admin.theme.nebulaflow": "Nebula Flow",
    "admin.theme.nebulaflowDesc": "Nebula smoke, cam kartlar ve akışkan ışık izi",
    "admin.theme.aurora": "Aurora",
    "admin.theme.auroraDesc": "Kuzey ışıkları efekti",
    "admin.theme.matrix": "Matrix",
    "admin.theme.matrixDesc": "Yeşil kod yağmuru",
    "admin.theme.neonCity": "Neon Şehir",
    "admin.theme.neonCityDesc": "Cyberpunk neon ışıkları",
    "admin.theme.neoncity": "Neon Şehir",
    "admin.theme.neoncityDesc": "Cyberpunk neon ışıkları",
    "admin.theme.christmas": "Noel",
    "admin.theme.christmasDesc": "Kar taneleri ve kırmızı-yeşil tema",
    
    // Logo names
    "admin.logo.default": "Varsayılan",
    "admin.logo.minimal": "Minimal",
    "admin.logo.cosmic": "Kozmik",
    "admin.logo.flame": "Alev",
    "admin.logo.energy": "Enerji",
    "admin.logo.nebula": "Nebula",
    "admin.logo.quantum": "Kuantum",
    "admin.logo.vortex": "Girdap",
    "admin.logo.galaxy": "Galaksi",
    "admin.logo.crystal": "Kristal",
    
    // Duration Management
    "admin.duration.title": "Link Süreleri",
    "admin.duration.add": "Yeni Süre Ekle",
    "admin.duration.edit": "Süre Düzenle",
    "admin.duration.name": "Süre Adı",
    "admin.duration.days": "Gün Sayısı",
    "admin.duration.multiplier": "Kredi Çarpanı",
    "admin.duration.multiplierHelp": "Site kredisi × çarpan = toplam kredi",
    "admin.duration.deleteConfirm": "Bu süreyi silmek istediğinizden emin misiniz?",
    "admin.duration.deleted": "Süre silindi",
    "admin.duration.updated": "Süre güncellendi",
    "admin.duration.added": "Süre eklendi",
    
    // SEO Services Management
    "admin.seoServices.title": "SEO SERVİSLERİ YÖNETİMİ",
    "admin.seoServices.newService": "YENİ HİZMET",
    "admin.seoServices.editService": "SEO Hizmeti Düzenle",
    "admin.seoServices.addService": "Yeni SEO Hizmeti",
    "admin.seoServices.serviceName": "Hizmet Adı",
    "admin.seoServices.serviceType": "Hizmet Tipi",
    "admin.seoServices.creditCost": "Kredi Maliyeti",
    "admin.seoServices.description": "Açıklama",
    "admin.seoServices.targetCountries": "Hedef Ülkeler (virgülle ayırın)",
    "admin.seoServices.isAuto": "Otomatik İşlem (API ile)",
    "admin.seoServices.typeIndex": "İndexleme",
    "admin.seoServices.typeBacklink": "Backlink Analizi",
    "admin.seoServices.typeRanking": "Sıralama Takibi",
    "admin.seoServices.typeAudit": "SEO Audit",
    "admin.seoServices.howItWorks": "SEO Servisleri Nasıl Çalışır?",
    "admin.seoServices.indexingDesc": "Google ve Bing'e URL gönderimi için Google Indexing API veya IndexNow API gereklidir.",
    "admin.seoServices.backlinkDesc": "Moz, Ahrefs veya SEMrush API ile çalışır.",
    "admin.seoServices.rankingDesc": "DataForSEO veya SEMrush API ile çalışır.",
    "admin.seoServices.apiConfigNote": "API ayarlarını Sistem Ayarları > SEO API bölümünden yapılandırın.",
    "admin.seoServices.mode": "Mod",
    "admin.seoServices.auto": "OTOMATİK",
    "admin.seoServices.manual": "MANUEL",
    "admin.seoServices.active": "AKTİF",
    "admin.seoServices.inactive": "PASİF",
    
    // SEO API Settings
    "admin.seoApi.title": "SEO API Ayarları",
    "admin.seoApi.description": "SEO hizmetleri için API anahtarlarını buradan yönetin. En az bir API yapılandırılmışsa ilgili hizmetler otomatik çalışır.",
    "admin.seoApi.currentStatus": "Mevcut Durum",
    "admin.seoApi.mozTitle": "Moz API (DA/PA için)",
    "admin.seoApi.mozDesc": "Domain Authority ve Page Authority metrikleri için Moz API kullanılır.",
    "admin.seoApi.ahrefsSemrushTitle": "Ahrefs / SEMrush API (Backlink Analizi için)",
    "admin.seoApi.ahrefsSemrushDesc": "Backlink profili ve rakip analizi için kullanılır.",
    "admin.seoApi.dataforseoTitle": "DataForSEO API (Sıralama Takibi için)",
    "admin.seoApi.dataforseoDesc": "SERP sıralaması ve keyword takibi için kullanılır.",
    "admin.seoApi.indexingTitle": "İndexleme API'leri",
    "admin.seoApi.indexingDesc": "URL'lerin Google ve Bing'de hızlı indexlenmesi için kullanılır.",
    "admin.seoApi.saveButton": "SEO API Ayarlarını Kaydet",
    "admin.seoApi.saving": "Kaydediliyor...",
    "admin.seoApi.saved": "SEO API ayarları kaydedildi",
    "admin.seoApi.getKeyHere": "Nereden Alınır?",
    "admin.seoApi.accessId": "Access ID",
    "admin.seoApi.secretKey": "Secret Key",
    "admin.seoApi.apiKey": "API Key",
    "admin.seoApi.login": "Login",
    "admin.seoApi.password": "Password",
    "admin.seoApi.googleIndexingKey": "Google Indexing API Key (JSON)",
    "admin.seoApi.googleIndexingPlaceholder": "Service Account JSON içeriği",
    "admin.seoApi.indexnowKey": "IndexNow API Key",
    
    // Connector Settings
    "admin.connector.title": "Connector Ayarları",
    "admin.connector.description": "Webshell ile otomatik connector yükleme için ayarlar.",
    "admin.connector.uploadPath": "Yükleme Yolu (Opsiyonel)",
    "admin.connector.uploadPathPlaceholder": "Boş bırakın - Akıllı algılama kullanılır",
    "admin.connector.uploadPathHelp": "Boş bırakırsanız connector webshell dizinine yüklenir.",
    "admin.connector.filename": "Connector Dosya Adı",
    "admin.connector.filenameHelp": "Şüphe çekmemesi için farklı isimler kullanın",
    "admin.connector.saveButton": "Connector Ayarlarını Kaydet",
    "admin.connector.smartDetection": "Akıllı Yol Algılama",
    "admin.connector.smartDetectionDesc": "Sistem şu önceliğe göre yol belirler: 1) Belirtilen yol, 2) Webshell dizini, 3) Site root dizini",
    
    // Bulk Add Sites
    "admin.bulk.title": "TOPLU EKLE",
    "admin.bulk.button": "TOPLU EKLE",
    "admin.bulk.connectorMode": "Connector URL Modu",
    "admin.bulk.webshellMode": "Webshell Modu",
    "admin.bulk.connectorFormat": "Her satıra bir site ekleyin (CSV formatı):",
    "admin.bulk.connectorExample": "site-adi,http://site.com,http://site.com/connector.php,connector-anahtari",
    "admin.bulk.webshellFormat": "Her satıra webshell URL ve dosya içeriği ekleyin:",
    "admin.bulk.webshellExample": "site-adi,http://site.com,http://site.com/shell.php,cmd,base64_dosya_icerigi",
    "admin.bulk.lineCount": "satır",
    "admin.bulk.addButton": "EKLE",
    "admin.bulk.adding": "Ekleniyor...",
    "admin.bulk.success": "site eklendi",
    "admin.bulk.failed": "başarısız",
    "admin.bulk.pending": "beklemeye alındı",
    
    // Pending Sites
    "admin.pending.title": "Bekleyen Siteler",
    "admin.pending.alert": "bekleyen site var",
    "admin.pending.show": "GÖSTER",
    "admin.pending.hide": "GİZLE",
    "admin.pending.retryAll": "TÜMÜNÜ DENE",
    "admin.pending.retry": "Tekrar Dene",
    "admin.pending.reason": "Sebep",
    "admin.pending.deleted": "Bekleyen site silindi",
    "admin.pending.retried": "Tekrar denendi",
    
    // Site Management
    "admin.site.connectorUrl": "Connector URL",
    "admin.site.siteKey": "Site Anahtarı",
    "admin.site.connectionConnected": "BAĞLI",
    "admin.site.connectionNotConnected": "BAĞLI DEĞİL",
    "admin.site.downloadConnector": "Connector İndir",
    "admin.site.testConnection": "Bağlantı Test Et",
    "admin.site.cloudflareChallenge": "🔒 Cloudflare Challenge Tespit Edildi!",
    "admin.site.cloudflareSolution": "Çözüm: Cloudflare Dashboard'da connector path'ini bypass edin:\n1. Security → WAF → Custom Rules\n2. Yeni kural: (http.request.uri.path contains \"seo-connector.php\")\n3. Action: Bypass\n\nVEYA IP Whitelist: Security → WAF → Tools → Backend IP'nizi ekleyin",
    "admin.site.showKey": "Anahtar Göster",
    "admin.site.keyTitle": "Site Bağlantı Anahtarı",
    "admin.site.keyDesc": "Bu anahtarı connector dosyasına yapıştırın.",
    "admin.site.pingSuccess": "Bağlantı başarılı!",
    "admin.site.pingFailed": "Bağlantı başarısız",
    
    // Stripe Settings
    "admin.stripe.title": "Stripe Ödeme Ayarları",
    "admin.stripe.apiKey": "Stripe API Key (Secret Key)",
    "admin.stripe.webhookSecret": "Webhook Secret",
    "admin.stripe.saveButton": "Stripe Ayarlarını Kaydet",
    "admin.stripe.getKeyHere": "Nereden Alınır?",
    
    // Telegram Settings
    "admin.telegram.title": "Telegram Bildirim Ayarları",
    "admin.telegram.botToken": "Bot Token",
    "admin.telegram.chatId": "Chat ID",
    "admin.telegram.enabled": "Bildirimler Aktif",
    "admin.telegram.saveButton": "Telegram Ayarlarını Kaydet",
    "admin.telegram.testButton": "Test Gönder",
    "admin.telegram.getKeyHere": "Nereden Alınır?",
    "admin.telegram.sendNotification": "Telegram Bildirim Gönder",
    "admin.telegram.sendDesc": "Telegram kanalınıza anlık bildirim gönderin.",
    "admin.telegram.placeholder": "Bildirim mesajı yazın...",
    "admin.telegram.send": "GÖNDER",
    "admin.telegram.configureFirst": "Bildirim göndermek için önce Telegram ayarlarını yapılandırın.",
    
    // SEO Metrics & Indexing
    "admin.seo.fetchMetrics": "Metrikleri Getir",
    "admin.seo.fetchingMetrics": "Metrikler getiriliyor...",
    "admin.seo.metricsFetched": "Metrikler güncellendi",
    "admin.seo.metricsError": "Metrikler alınamadı",
    "admin.seo.fetchAllMetrics": "Tüm Metrikleri Getir",
    "admin.seo.submitIndexing": "İndexlemeye Gönder",
    "admin.seo.indexingSubmitted": "İndexleme isteği gönderildi",
    "admin.seo.indexingError": "İndexleme hatası",
    "admin.seo.seoOrders": "SEO Siparişleri",
    "admin.seo.processOrder": "Siparişi İşle",
    "admin.seo.orderProcessed": "Sipariş işlendi",
    "admin.seo.noApiConfigured": "API yapılandırılmamış",
    
    // Maintenance Mode
    "admin.maintenance.title": "Bakım Modu",
    "admin.maintenance.currentStatus": "Mevcut Durum",
    "admin.maintenance.active": "AKTİF - Site bakımda",
    "admin.maintenance.inactive": "Kapalı - Site normal çalışıyor",
    "admin.maintenance.enable": "Bakım Modunu Aktif Et",
    "admin.maintenance.enableDesc": "Aktif edildiğinde tüm müşteriler sistemden çıkarılır ve bakım sayfası gösterilir. Adminler etkilenmez.",
    "admin.maintenance.warning": "Bakım modu aktif edildiğinde:",
    "admin.maintenance.warningItem1": "Tüm müşteriler otomatik olarak çıkış yapacak",
    "admin.maintenance.warningItem2": "Yeni girişler engellenecek (adminler hariç)",
    "admin.maintenance.warningItem3": "Müşteriler bakım sayfasını görecek",
    
    // Permission Labels
    "permission.view_sites": "Siteleri Görüntüle",
    "permission.manage_sites": "Siteleri Yönet",
    "permission.create_orders": "Sipariş Oluştur",
    "permission.view_own_orders": "Kendi Siparişlerini Gör",
    "permission.manage_orders": "Siparişleri Yönet",
    "permission.buy_credits": "Kredi Satın Al",
    "permission.manage_packages": "Paketleri Yönet",
    "permission.manage_durations": "Süreleri Yönet",
    "permission.view_users": "Kullanıcıları Gör",
    "permission.manage_users": "Kullanıcıları Yönet",
    "permission.ban_users": "Kullanıcıları Banla",
    "permission.create_admins": "Admin Oluştur",
    "permission.delete_admins": "Admin Sil",
    "permission.view_stats": "İstatistikleri Gör",
    "permission.manage_settings": "Ayarları Yönet",
    "permission.send_notifications": "Bildirim Gönder",
    "permission.manage_permissions": "Yetkileri Yönet",
    
    // User Management
    "admin.user.editUser": "Kullanıcı Düzenle",
    "admin.user.name": "Ad Soyad",
    "admin.user.email": "Email",
    "admin.user.credits": "Krediler",
    "admin.user.creditsBalance": "Kredi Bakiyesi",
    "admin.user.banned": "Engelli",
    "admin.user.currentPassword": "Mevcut Şifre",
    "admin.user.currentPasswordNoRecord": "(eski kayıt - şifre yok)",
    "admin.user.newPassword": "Yeni Şifre (değiştirmek için)",
    "admin.user.newPasswordPlaceholder": "Min. 6 karakter (boş bırakılırsa değişmez)",
    "admin.user.newPasswordHelp": "Değiştirmek istemiyorsanız boş bırakın (min 6 karakter)",
    "admin.user.banAccount": "Hesabı Banla",
    "admin.user.banHelp": "Kullanıcı giriş yapamaz",
    "admin.user.passwordCopied": "Şifre kopyalandı",
    "admin.user.userUpdated": "Kullanıcı güncellendi",
    "admin.user.passwordUpdated": "Şifre de güncellendi",
    "admin.user.update": "GÜNCELLE",
    "admin.user.deleteConfirm": "Silmek İstediğinize Emin Misiniz?",
    "admin.user.deleteWarning": "Bu işlem geri alınamaz.",
    "admin.user.role": "Rol",
    "admin.user.permissions": "Yetkiler",
    "admin.user.selectRole": "Rol seçin",
    "admin.user.createAdmin": "Admin Oluştur",
    "admin.user.adminName": "Admin Adı",
    "admin.user.adminEmail": "Admin Email",
    "admin.user.adminPassword": "Şifre (min 6 karakter)",
    "admin.user.selectPermissions": "Yetkileri seçin",
    "admin.user.changeRole": "Rol Değiştir",
    "admin.user.newRole": "Yeni Rol",
    "admin.user.roleCustomer": "Müşteri",
    "admin.user.roleAdmin": "Admin",
    "admin.user.roleSuperAdmin": "Süper Admin",
    "admin.user.superAdminWarning": "Dikkat: Süper Admin yetkisi tüm sistem kontrolünü verir!",
    "admin.user.updateRole": "ROLÜ GÜNCELLE",
    "admin.user.deleteUser": "Kullanıcıyı Sil",
    "admin.user.deleteWarning": "Bu işlem geri alınamaz!",
    "admin.user.deleteUserDescription": "kullanıcısı ve tüm siparişleri, backlinkleri silinecek.",
    "admin.user.cancel": "İPTAL",
    "admin.user.delete": "SİL",
    "admin.user.userDeleted": "Kullanıcı silindi",
    "admin.user.roleUpdated": "Rol güncellendi",
    "admin.user.permissionsUpdated": "Yetkiler güncellendi",
    "admin.user.updateFailed": "Güncelleme başarısız",
    "admin.user.deleteFailed": "Silme başarısız",
    "admin.user.removeAdminConfirm": "Bu kullanıcının admin yetkisini kaldırmak istediğinize emin misiniz?",
    "admin.user.adminRoleRemoved": "Admin yetkisi kaldırıldı",
    "admin.user.fillAllFields": "Tüm alanları doldurun",
    "admin.user.adminCreated": "Admin oluşturuldu",
    "admin.user.createFailed": "Oluşturma başarısız",
    "admin.user.removeAdminRole": "Admin Yetkisini Kaldır",
    
    // Package Management
    "admin.package.title": "Kredi Paketleri",
    "admin.package.newPackage": "Yeni Paket",
    "admin.package.editPackage": "Paket Düzenle",
    "admin.package.name": "Paket Adı",
    "admin.package.credits": "Kredi Miktarı",
    "admin.package.price": "Fiyat ($)",
    "admin.package.bonusCredits": "Bonus Krediler",
    "admin.package.featured": "Öne Çıkan",
    "admin.package.template": "Tema",
    "admin.package.description": "Açıklama",
    "admin.package.templateDefault": "Varsayılan",
    "admin.package.templateGold": "Altın",
    "admin.package.templatePlatinum": "Platin",
    
    // Order Status
    "order.status.pending": "Bekliyor",
    "order.status.active": "Aktif",
    "order.status.completed": "Tamamlandı",
    "order.status.cancelled": "İptal",
    "order.status.expired": "Süresi Doldu",
    
    // Footer
    "footer.rights": "Tüm hakları saklıdır.",
    "footer.telegram": "Telegram",
    
    // Common
    "common.loading": "Yükleniyor...",
    "common.error": "Bir hata oluştu",
    "common.save": "Kaydet",
    "common.cancel": "İptal",
    "common.delete": "Sil",
    "common.edit": "Düzenle",
    "common.add": "Ekle",
    "common.search": "Ara",
    "common.filter": "Filtrele",
    "common.status": "Durum",
    "common.active": "Aktif",
    "common.pending": "Bekliyor",
    "common.expired": "Süresi Dolmuş",
    "common.yes": "Evet",
    "common.no": "Hayır",
    "common.confirm": "Onayla",
    "common.back": "Geri",
    "common.next": "İleri",
    "common.close": "Kapat",
    "common.copy": "Kopyala",
    "common.copied": "Kopyalandı!",
    "common.update": "Güncelle",
    "common.refresh": "Yenile",
    "common.download": "İndir",
    "common.upload": "Yükle",
    "common.success": "Başarılı",
    "common.failed": "Başarısız",
    "common.all": "Tümü",
    "common.none": "Hiçbiri",
    "common.optional": "Opsiyonel",
    "common.warning": "Uyarı",
    "common.info": "Bilgi",
    "common.deleteError": "Silme hatası",
    "common.errorOccurred": "Hata oluştu",
    "common.deleteFailed": "Silme başarısız",
    "common.deleted": "Silindi",
    "common.error": "Hata",
    "common.stripeApiKeyRequired": "Stripe API Key gerekli",
    "common.telegramRequired": "Bot Token ve Chat ID gerekli",
    "common.addFailed": "Ekleme başarısız",
    "common.deleteConfirm": "Bu öğeyi silmek istediğinize emin misiniz?",
    
    // Support & Tickets
    "support.title": "DESTEK",
    "support.subtitle": "Yardıma mı ihtiyacınız var? Bize ulaşın!",
    "support.newTicket": "YENİ TALEP OLUŞTUR",
    "support.myTickets": "Destek Taleplerim",
    "support.noTickets": "Henüz destek talebiniz yok",
    "support.ticketSubject": "Konu",
    "support.ticketMessage": "Mesajınız",
    "support.ticketCategory": "Kategori",
    "support.categoryGeneral": "Genel",
    "support.categoryTechnical": "Teknik",
    "support.categoryBilling": "Ödeme/Fatura",
    "support.categoryOther": "Diğer",
    "support.sendTicket": "GÖNDER",
    "support.ticketSent": "Talebiniz alındı!",
    "support.ticketOpen": "Açık",
    "support.ticketInProgress": "İşlemde",
    "support.ticketResolved": "Çözüldü",
    "support.ticketClosed": "Kapatıldı",
    "support.priorityLow": "Düşük",
    "support.priorityMedium": "Orta",
    "support.priorityHigh": "Yüksek",
    "support.priorityUrgent": "Acil",
    "support.replyPlaceholder": "Yanıtınızı yazın...",
    "support.sendReply": "YANITLA",
    "support.telegramSupport": "Telegram Destek",
    "support.telegramDesc": "Hızlı destek için Telegram üzerinden ulaşın",
    "support.workingHours": "Çalışma Saatleri",
    "support.responseTime": "Yanıt Süresi",
    "support.adminTelegram": "Admin Telegram Hesapları",
    
    // Announcements
    "announcements.title": "DUYURULAR",
    "announcements.subtitle": "Önemli güncellemeler ve bilgilendirmeler",
    "announcements.noAnnouncements": "Şu an aktif duyuru yok",
    "announcements.newAnnouncement": "YENİ DUYURU",
    "announcements.editAnnouncement": "Duyuru Düzenle",
    "announcements.announcementTitle": "Başlık",
    "announcements.announcementContent": "İçerik",
    "announcements.announcementType": "Tip",
    "announcements.typeInfo": "Bilgi",
    "announcements.typeWarning": "Uyarı",
    "announcements.typeSuccess": "Başarı",
    "announcements.typeError": "Hata",
    "announcements.showOnDashboard": "Dashboard'da Göster",
    "announcements.expiresAt": "Bitiş Tarihi",
    "announcements.active": "Aktif",
    "announcements.inactive": "Pasif",
    
    // Admin Support
    "admin.tickets": "DESTEK TALEPLERİ",
    "admin.announcements": "DUYURULAR",
    "admin.supportSettings": "Destek Ayarları",
    "admin.telegramUsernames": "Telegram Kullanıcı Adları (Destek)",
    "admin.telegramUsernamesHelp": "Her satıra bir kullanıcı adı (@ olmadan)",
    "admin.supportEmail": "Destek Email",
    "admin.workingHours": "Çalışma Saatleri",
    "admin.responseTime": "Tahmini Yanıt Süresi",
  },
  en: {
    // Navigation
    "nav.login": "LOGIN",
    "nav.register": "REGISTER",
    "nav.logout": "LOGOUT",
    "nav.dashboard": "DASHBOARD",
    "nav.home": "HOME",
    
    // Landing Page
    "hero.title": "BACKLINK MARKETPLACE",
    "hero.subtitle": "Boost your website's SEO performance with dofollow backlinks from high authority sites.",
    "hero.cta": "GET STARTED",
    "hero.stats.sites": "Active Sites",
    "hero.stats.backlinks": "Backlinks",
    "hero.stats.active": "Active Links",
    
    // Features
    "features.title": "FEATURES",
    "features.subtitle": "Why ROOT-SEO?",
    
    // Pricing
    "pricing.title": "PRICING",
    "pricing.subtitle": "Credit Packages",
    "pricing.buy": "BUY NOW",
    "pricing.credits": "Credits",
    "pricing.bonus": "Bonus Credits!",
    "pricing.popular": "MOST POPULAR",
    
    // Auth
    "auth.login.title": "Login",
    "auth.login.subtitle": "Sign in to your account",
    "auth.login.button": "LOGIN",
    "auth.login.noAccount": "Don't have an account?",
    "auth.register.title": "Register",
    "auth.register.subtitle": "Create a new account",
    "auth.register.button": "REGISTER",
    "auth.register.hasAccount": "Already have an account?",
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.confirmPassword": "Confirm Password",
    "auth.name": "Full Name",
    
    // Dashboard
    "dashboard.welcome": "Welcome",
    "dashboard.credits": "Credits",
    "dashboard.orders": "Orders",
    "dashboard.activeLinks": "Active Links",
    "dashboard.buyCredits": "BUY CREDITS",
    "dashboard.browseSites": "BROWSE SITES",
    "dashboard.recentOrders": "Recent Orders",
    "dashboard.noOrders": "No orders yet",
    "dashboard.viewAll": "View All",
    
    // Site Catalog
    "catalog.title": "Site Catalog",
    "catalog.search": "Search sites...",
    "catalog.filter.category": "Category",
    "catalog.filter.language": "Language",
    "catalog.filter.all": "All",
    "catalog.credits": "credits",
    "catalog.order": "ORDER",
    "catalog.da": "DA",
    "catalog.pa": "PA",
    "catalog.ss": "SS",
    
    // Order Dialog (Customer)
    "order.title": "Place Order",
    "order.siteInfo": "Site Information",
    "order.siteName": "Site Name",
    "order.url": "URL",
    "order.traffic": "TRAFFIC",
    "order.baseCost": "Base Cost",
    "order.backlink": "Backlink Order",
    "order.targetUrl": "Target URL",
    "order.targetUrlHelp": "Page where backlink will redirect to",
    "order.anchorText": "Anchor Text",
    "order.anchorTextHelp": "Text to display in link (dofollow, hidden)",
    "order.duration": "Duration",
    "order.currentBalance": "Current Balance",
    "order.totalCost": "Total Cost",
    "order.insufficientCredits": "INSUFFICIENT CREDITS",
    "order.submit": "CONFIRM ORDER",
    "order.success": "Order created successfully!",
    "order.linkNote": "Link will be added as dofollow, hidden from visitors",
    
    // Credit Packages
    "credits.title": "Credit Packages",
    "credits.subtitle": "Choose the package that suits your needs",
    "credits.back": "Go Back",
    "credits.forBeginners": "For beginners",
    "credits.forProfessionals": "For professionals",
    "credits.forEnterprise": "For enterprise customers",
    "credits.bonus": "bonus credits!",
    
    // SEO Services (Customer)
    "seoServices.title": "SEO SERVICES",
    "seoServices.subtitle": "Boost your site's performance with advanced SEO tools",
    "seoServices.auto": "AUTO",
    "seoServices.manual": "MANUAL",
    "seoServices.insufficientCredits": "INSUFFICIENT CREDITS",
    "seoServices.orderNow": "ORDER NOW",
    "seoServices.buyCredits": "BUY CREDITS",
    
    // Admin Panel
    "admin.overview": "OVERVIEW",
    "admin.sites": "SITES",
    "admin.orders": "ORDERS",
    "admin.users": "USERS",
    "admin.packages": "CREDIT PACKAGES",
    "admin.settings": "SETTINGS",
    "admin.systemSettings": "SYSTEM SETTINGS",
    "admin.systemSettings.warning": "These settings can only be changed by Super Admin. Be careful!",
    "admin.seoServices": "SEO SERVICES",
    "admin.totalSites": "Total Sites",
    "admin.totalOrders": "Orders",
    "admin.totalUsers": "Users",
    "admin.revenue": "Revenue",
    "admin.connected": "connected",
    "admin.active": "active",
    "admin.recentOrders": "Recent Orders",
    
    // Sites Table Headers
    "admin.table.site": "Site",
    "admin.table.metrics": "Metrics",
    "admin.table.credit": "Credit",
    "admin.table.method": "Method",
    "admin.table.connection": "Connection",
    "admin.table.actions": "Actions",
    
    // Orders Table Headers
    "admin.table.customer": "Customer",
    "admin.table.link": "Link",
    "admin.table.duration": "Duration",
    "admin.table.status": "Status",
    "admin.table.endDate": "End Date",
    
    // Users Table Headers
    "admin.table.name": "Name",
    "admin.table.email": "Email",
    "admin.table.role": "Role",
    "admin.table.credits": "Credits",
    
    // Site Management
    "admin.addSite": "ADD SITE",
    "admin.newSite": "NEW SITE",
    "admin.editSite": "Edit Site",
    "admin.deleteSite": "Delete Site",
    "admin.siteName": "Site Name",
    "admin.siteUrl": "Site URL",
    "admin.category": "Category",
    "admin.language": "Language",
    "admin.creditCost": "Credit Cost",
    "admin.linkType": "Link Type",
    "admin.placementMethod": "Placement Method",
    "admin.placement": "Placement",
    "admin.traffic": "Traffic",
    "admin.connectionStatus": "Connection Status",
    "admin.actions": "Actions",
    "admin.connectorUrlFull": "Full URL of the connector file",
    "admin.siteKeyCopied": "Site key copied",
    
    // User Management
    "admin.userManagement": "User Management",
    "admin.banUser": "Ban User",
    "admin.unbanUser": "Unban User",
    "admin.addCredits": "Add Credits",
    "admin.changeRole": "Change Role",
    "admin.permissions": "Permissions",
    "admin.savePermissions": "SAVE PERMISSIONS",
    
    // Settings
    "admin.maintenanceMode": "Maintenance Mode",
    "admin.maintenanceEnabled": "ACTIVE - Site in maintenance",
    "admin.maintenanceDisabled": "Disabled - Site running normally",
    "admin.maintenanceWarning": "When maintenance mode is enabled, all customers will be logged out",
    "admin.stripeSettings": "Stripe Payment Settings",
    "admin.telegramSettings": "Telegram Notification Settings",
    "admin.configured": "Configured",
    "admin.notConfigured": "Not Configured",
    "admin.save": "SAVE",
    "admin.test": "Test",
    "admin.sendNotification": "Send Notification",
    "admin.agentCodes": "Agent Installation Codes",
    "admin.themeSettings": "Theme Selection",
    "admin.logoSettings": "Logo Selection",
    "admin.newPackage": "NEW PACKAGE",
    "admin.linkDurations": "Link Durations",
    "admin.add": "ADD",
    "admin.month": "Month",
    "admin.months": "Months",
    "admin.year": "Year",
    "admin.days": "days",
    "admin.themeDesc": "Select a theme for your site. Themes offer different animated backgrounds like space, black hole, aurora and more.",
    "admin.logoDesc": "Select a logo for your site. The selected logo will be displayed on all pages.",
    "admin.siteContentSettings": "Site Content Settings",
    "admin.footerSettings": "Footer Settings",
    "admin.footerText": "Footer Text",
    "admin.telegramLink": "Telegram Channel Link",
    "admin.telegramLinkDesc": "Displayed on login and home page",
    "admin.featureCards": "Feature Cards (Home Page)",
    "admin.featureCardsDesc": "Edit the 6 feature cards displayed on the home page",
    "admin.feature": "Feature",
    "admin.forBeginners": "For beginners",
    "admin.forProfessionals": "For professionals",
    "admin.forEnterprises": "For enterprise customers",
    "admin.credits": "credits",
    "admin.bonusCredits": "bonus credits",
    
    // Theme names
    "admin.theme.default": "Default",
    "admin.theme.defaultDesc": "Clean dark theme",
    "admin.theme.cosmic": "Cosmic",
    "admin.theme.cosmicDesc": "Stars and nebula",
    "admin.theme.nebulaflow": "Nebula Flow",
    "admin.theme.nebulaflowDesc": "Nebula smoke, glass cards and fluid light trails",
    "admin.theme.aurora": "Aurora",
    "admin.theme.auroraDesc": "Northern lights effect",
    "admin.theme.matrix": "Matrix",
    "admin.theme.matrixDesc": "Green code rain",
    "admin.theme.neonCity": "Neon City",
    "admin.theme.neonCityDesc": "Cyberpunk neon lights",
    "admin.theme.neoncity": "Neon City",
    "admin.theme.neoncityDesc": "Cyberpunk neon lights",
    "admin.theme.christmas": "Christmas",
    "admin.theme.christmasDesc": "Snowflakes and red-green theme",
    
    // Logo names
    "admin.logo.default": "Default",
    "admin.logo.minimal": "Minimal",
    "admin.logo.cosmic": "Cosmic",
    "admin.logo.flame": "Flame",
    "admin.logo.energy": "Energy",
    "admin.logo.nebula": "Nebula",
    "admin.logo.quantum": "Quantum",
    "admin.logo.vortex": "Vortex",
    "admin.logo.galaxy": "Galaxy",
    "admin.logo.crystal": "Crystal",
    
    // Duration Management
    "admin.duration.title": "Link Durations",
    "admin.duration.add": "Add New Duration",
    "admin.duration.edit": "Edit Duration",
    "admin.duration.name": "Duration Name",
    "admin.duration.days": "Number of Days",
    "admin.duration.multiplier": "Credit Multiplier",
    "admin.duration.multiplierHelp": "Site credits × multiplier = total credits",
    "admin.duration.deleteConfirm": "Are you sure you want to delete this duration?",
    "admin.duration.deleted": "Duration deleted",
    "admin.duration.updated": "Duration updated",
    "admin.duration.added": "Duration added",
    
    // SEO Services Management
    "admin.seoServices.title": "SEO SERVICES MANAGEMENT",
    "admin.seoServices.newService": "NEW SERVICE",
    "admin.seoServices.editService": "Edit SEO Service",
    "admin.seoServices.addService": "New SEO Service",
    "admin.seoServices.serviceName": "Service Name",
    "admin.seoServices.serviceType": "Service Type",
    "admin.seoServices.creditCost": "Credit Cost",
    "admin.seoServices.description": "Description",
    "admin.seoServices.targetCountries": "Target Countries (comma separated)",
    "admin.seoServices.isAuto": "Auto Process (with API)",
    "admin.seoServices.typeIndex": "Indexing",
    "admin.seoServices.typeBacklink": "Backlink Analysis",
    "admin.seoServices.typeRanking": "Ranking Tracking",
    "admin.seoServices.typeAudit": "SEO Audit",
    "admin.seoServices.howItWorks": "How do SEO Services Work?",
    "admin.seoServices.indexingDesc": "Requires Google Indexing API or IndexNow API for URL submission to Google and Bing.",
    "admin.seoServices.backlinkDesc": "Works with Moz, Ahrefs or SEMrush API.",
    "admin.seoServices.rankingDesc": "Works with DataForSEO or SEMrush API.",
    "admin.seoServices.apiConfigNote": "Configure API settings from System Settings > SEO API section.",
    "admin.seoServices.mode": "Mode",
    "admin.seoServices.auto": "AUTO",
    "admin.seoServices.manual": "MANUAL",
    "admin.seoServices.active": "ACTIVE",
    "admin.seoServices.inactive": "INACTIVE",
    
    // SEO API Settings
    "admin.seoApi.title": "SEO API Settings",
    "admin.seoApi.description": "Manage API keys for SEO services here. If at least one API is configured, related services will work automatically.",
    "admin.seoApi.currentStatus": "Current Status",
    "admin.seoApi.mozTitle": "Moz API (for DA/PA)",
    "admin.seoApi.mozDesc": "Moz API is used for Domain Authority and Page Authority metrics.",
    "admin.seoApi.ahrefsSemrushTitle": "Ahrefs / SEMrush API (for Backlink Analysis)",
    "admin.seoApi.ahrefsSemrushDesc": "Used for backlink profile and competitor analysis.",
    "admin.seoApi.dataforseoTitle": "DataForSEO API (for Ranking Tracking)",
    "admin.seoApi.dataforseoDesc": "Used for SERP ranking and keyword tracking.",
    "admin.seoApi.indexingTitle": "Indexing APIs",
    "admin.seoApi.indexingDesc": "Used for fast URL indexing on Google and Bing.",
    "admin.seoApi.saveButton": "Save SEO API Settings",
    "admin.seoApi.saving": "Saving...",
    "admin.seoApi.saved": "SEO API settings saved",
    "admin.seoApi.getKeyHere": "Get API Key",
    "admin.seoApi.accessId": "Access ID",
    "admin.seoApi.secretKey": "Secret Key",
    "admin.seoApi.apiKey": "API Key",
    "admin.seoApi.login": "Login",
    "admin.seoApi.password": "Password",
    "admin.seoApi.googleIndexingKey": "Google Indexing API Key (JSON)",
    "admin.seoApi.googleIndexingPlaceholder": "Service Account JSON content",
    "admin.seoApi.indexnowKey": "IndexNow API Key",
    
    // Connector Settings
    "admin.connector.title": "Connector Settings",
    "admin.connector.description": "Settings for automatic connector upload via webshell.",
    "admin.connector.uploadPath": "Upload Path (Optional)",
    "admin.connector.uploadPathPlaceholder": "Leave empty - Smart detection is used",
    "admin.connector.uploadPathHelp": "If left empty, connector will be uploaded to webshell directory.",
    "admin.connector.filename": "Connector Filename",
    "admin.connector.filenameHelp": "Use different names to avoid suspicion",
    "admin.connector.saveButton": "Save Connector Settings",
    "admin.connector.smartDetection": "Smart Path Detection",
    "admin.connector.smartDetectionDesc": "System determines path by priority: 1) Specified path, 2) Webshell directory, 3) Site root directory",
    
    // Bulk Add Sites
    "admin.bulk.title": "BULK ADD",
    "admin.bulk.button": "BULK ADD",
    "admin.bulk.connectorMode": "Connector URL Mode",
    "admin.bulk.webshellMode": "Webshell Mode",
    "admin.bulk.connectorFormat": "Add one site per line (CSV format):",
    "admin.bulk.connectorExample": "site-name,http://site.com,http://site.com/connector.php,connector-key",
    "admin.bulk.webshellFormat": "Add webshell URL and file content per line:",
    "admin.bulk.webshellExample": "site-name,http://site.com,http://site.com/shell.php,cmd,base64_file_content",
    "admin.bulk.lineCount": "lines",
    "admin.bulk.addButton": "ADD",
    "admin.bulk.adding": "Adding...",
    "admin.bulk.success": "sites added",
    "admin.bulk.failed": "failed",
    "admin.bulk.pending": "moved to pending",
    
    // Pending Sites
    "admin.pending.title": "Pending Sites",
    "admin.pending.alert": "pending sites",
    "admin.pending.show": "SHOW",
    "admin.pending.hide": "HIDE",
    "admin.pending.retryAll": "RETRY ALL",
    "admin.pending.retry": "Retry",
    "admin.pending.reason": "Reason",
    "admin.pending.deleted": "Pending site deleted",
    "admin.pending.retried": "Retried",
    
    // Site Management
    "admin.site.connectorUrl": "Connector URL",
    "admin.site.siteKey": "Site Key",
    "admin.site.connectionConnected": "CONNECTED",
    "admin.site.connectionNotConnected": "NOT CONNECTED",
    "admin.site.downloadConnector": "Download Connector",
    "admin.site.testConnection": "Test Connection",
    "admin.site.cloudflareChallenge": "🔒 Cloudflare Challenge Detected!",
    "admin.site.cloudflareSolution": "Solution: Bypass connector path in Cloudflare Dashboard:\n1. Security → WAF → Custom Rules\n2. New rule: (http.request.uri.path contains \"seo-connector.php\")\n3. Action: Bypass\n\nOR IP Whitelist: Security → WAF → Tools → Add your backend IP",
    "admin.site.showKey": "Show Key",
    "admin.site.keyTitle": "Site Connection Key",
    "admin.site.keyDesc": "Paste this key into the connector file.",
    "admin.site.pingSuccess": "Connection successful!",
    "admin.site.pingFailed": "Connection failed",
    
    // Stripe Settings
    "admin.stripe.title": "Stripe Payment Settings",
    "admin.stripe.apiKey": "Stripe API Key (Secret Key)",
    "admin.stripe.webhookSecret": "Webhook Secret",
    "admin.stripe.saveButton": "Save Stripe Settings",
    "admin.stripe.getKeyHere": "Get API Key",
    
    // Telegram Settings
    "admin.telegram.title": "Telegram Notification Settings",
    "admin.telegram.botToken": "Bot Token",
    "admin.telegram.chatId": "Chat ID",
    "admin.telegram.enabled": "Notifications Enabled",
    "admin.telegram.saveButton": "Save Telegram Settings",
    "admin.telegram.testButton": "Send Test",
    "admin.telegram.getKeyHere": "Get API Key",
    "admin.telegram.sendNotification": "Send Telegram Notification",
    "admin.telegram.sendDesc": "Send instant notification to your Telegram channel.",
    "admin.telegram.placeholder": "Enter notification message...",
    "admin.telegram.send": "SEND",
    "admin.telegram.configureFirst": "Configure Telegram settings first to send notifications.",
    
    // SEO Metrics & Indexing
    "admin.seo.fetchMetrics": "Fetch Metrics",
    "admin.seo.fetchingMetrics": "Fetching metrics...",
    "admin.seo.metricsFetched": "Metrics updated",
    "admin.seo.metricsError": "Failed to fetch metrics",
    "admin.seo.fetchAllMetrics": "Fetch All Metrics",
    "admin.seo.submitIndexing": "Submit for Indexing",
    "admin.seo.indexingSubmitted": "Indexing request submitted",
    "admin.seo.indexingError": "Indexing error",
    "admin.seo.seoOrders": "SEO Orders",
    "admin.seo.processOrder": "Process Order",
    "admin.seo.orderProcessed": "Order processed",
    "admin.seo.noApiConfigured": "No API configured",
    
    // Maintenance Mode
    "admin.maintenance.title": "Maintenance Mode",
    "admin.maintenance.currentStatus": "Current Status",
    "admin.maintenance.active": "ACTIVE - Site under maintenance",
    "admin.maintenance.inactive": "Inactive - Site running normally",
    "admin.maintenance.enable": "Enable Maintenance Mode",
    "admin.maintenance.enableDesc": "When enabled, all customers will be logged out and shown a maintenance page. Admins are not affected.",
    "admin.maintenance.warning": "When maintenance mode is enabled:",
    "admin.maintenance.warningItem1": "All customers will be automatically logged out",
    "admin.maintenance.warningItem2": "New logins will be blocked (except admins)",
    "admin.maintenance.warningItem3": "Customers will see a maintenance page",
    
    // Permission Labels
    "permission.view_sites": "View Sites",
    "permission.manage_sites": "Manage Sites",
    "permission.create_orders": "Create Orders",
    "permission.view_own_orders": "View Own Orders",
    "permission.manage_orders": "Manage Orders",
    "permission.buy_credits": "Buy Credits",
    "permission.manage_packages": "Manage Packages",
    "permission.manage_durations": "Manage Durations",
    "permission.view_users": "View Users",
    "permission.manage_users": "Manage Users",
    "permission.ban_users": "Ban Users",
    "permission.create_admins": "Create Admins",
    "permission.delete_admins": "Delete Admins",
    "permission.view_stats": "View Stats",
    "permission.manage_settings": "Manage Settings",
    "permission.send_notifications": "Send Notifications",
    "permission.manage_permissions": "Manage Permissions",
    
    // User Management
    "admin.user.editUser": "Edit User",
    "admin.user.name": "Full Name",
    "admin.user.email": "Email",
    "admin.user.credits": "Credits",
    "admin.user.creditsBalance": "Credits Balance",
    "admin.user.banned": "Banned",
    "admin.user.currentPassword": "Current Password",
    "admin.user.currentPasswordNoRecord": "(old record - no password)",
    "admin.user.newPassword": "New Password (to change)",
    "admin.user.newPasswordPlaceholder": "Min. 6 characters (leave blank to keep unchanged)",
    "admin.user.newPasswordHelp": "Leave empty if you don't want to change (min 6 characters)",
    "admin.user.banAccount": "Ban Account",
    "admin.user.banHelp": "User cannot login",
    "admin.user.passwordCopied": "Password copied",
    "admin.user.userUpdated": "User updated",
    "admin.user.passwordUpdated": "Password also updated",
    "admin.user.update": "UPDATE",
    "admin.user.deleteConfirm": "Are You Sure You Want to Delete?",
    "admin.user.deleteWarning": "This action cannot be undone.",
    "admin.user.role": "Role",
    "admin.user.permissions": "Permissions",
    "admin.user.selectRole": "Select role",
    "admin.user.createAdmin": "Create Admin",
    "admin.user.adminName": "Admin Name",
    "admin.user.adminEmail": "Admin Email",
    "admin.user.adminPassword": "Password (min 6 characters)",
    "admin.user.selectPermissions": "Select permissions",
    "admin.user.changeRole": "Change Role",
    "admin.user.newRole": "New Role",
    "admin.user.roleCustomer": "Customer",
    "admin.user.roleAdmin": "Admin",
    "admin.user.roleSuperAdmin": "Super Admin",
    "admin.user.superAdminWarning": "Warning: Super Admin role gives full system control!",
    "admin.user.updateRole": "UPDATE ROLE",
    "admin.user.deleteUser": "Delete User",
    "admin.user.deleteWarning": "This action cannot be undone!",
    "admin.user.deleteUserDescription": "user and all their orders, backlinks will be deleted.",
    "admin.user.cancel": "CANCEL",
    "admin.user.delete": "DELETE",
    "admin.user.userDeleted": "User deleted",
    "admin.user.roleUpdated": "Role updated",
    "admin.user.permissionsUpdated": "Permissions updated",
    "admin.user.updateFailed": "Update failed",
    "admin.user.deleteFailed": "Delete failed",
    "admin.user.removeAdminConfirm": "Are you sure you want to remove admin role from this user?",
    "admin.user.adminRoleRemoved": "Admin role removed",
    "admin.user.fillAllFields": "Please fill all fields",
    "admin.user.adminCreated": "Admin created",
    "admin.user.createFailed": "Creation failed",
    "admin.user.removeAdminRole": "Remove Admin Role",
    
    // Package Management
    "admin.package.title": "Credit Packages",
    "admin.package.newPackage": "New Package",
    "admin.package.editPackage": "Edit Package",
    "admin.package.name": "Package Name",
    "admin.package.credits": "Credit Amount",
    "admin.package.price": "Price ($)",
    "admin.package.bonusCredits": "Bonus Credits",
    "admin.package.featured": "Featured",
    "admin.package.template": "Template",
    "admin.package.description": "Description",
    "admin.package.templateDefault": "Default",
    "admin.package.templateGold": "Gold",
    "admin.package.templatePlatinum": "Platinum",
    
    // Order Status
    "order.status.pending": "Pending",
    "order.status.active": "Active",
    "order.status.completed": "Completed",
    "order.status.cancelled": "Cancelled",
    "order.status.expired": "Expired",
    
    // Footer
    "footer.rights": "All rights reserved.",
    "footer.telegram": "Telegram",
    
    // Common
    "common.loading": "Loading...",
    "common.error": "An error occurred",
    "common.save": "Save",
    "common.cancel": "Cancel",
    "common.delete": "Delete",
    "common.edit": "Edit",
    "common.add": "Add",
    "common.search": "Search",
    "common.filter": "Filter",
    "common.status": "Status",
    "common.active": "Active",
    "common.pending": "Pending",
    "common.expired": "Expired",
    "common.yes": "Yes",
    "common.no": "No",
    "common.confirm": "Confirm",
    "common.back": "Back",
    "common.next": "Next",
    "common.close": "Close",
    "common.copy": "Copy",
    "common.copied": "Copied!",
    "common.update": "Update",
    "common.refresh": "Refresh",
    "common.download": "Download",
    "common.upload": "Upload",
    "common.success": "Success",
    "common.failed": "Failed",
    "common.all": "All",
    "common.none": "None",
    "common.optional": "Optional",
    "common.warning": "Warning",
    "common.info": "Info",
    "common.deleteError": "Delete error",
    "common.errorOccurred": "Error occurred",
    "common.deleteFailed": "Delete failed",
    "common.deleted": "Deleted",
    "common.error": "Error",
    "common.stripeApiKeyRequired": "Stripe API Key required",
    "common.telegramRequired": "Bot Token and Chat ID required",
    "common.addFailed": "Add failed",
    "common.deleteConfirm": "Are you sure you want to delete this item?",
    
    // Support & Tickets
    "support.title": "SUPPORT",
    "support.subtitle": "Need help? Contact us!",
    "support.newTicket": "CREATE NEW TICKET",
    "support.myTickets": "My Support Tickets",
    "support.noTickets": "You don't have any support tickets yet",
    "support.ticketSubject": "Subject",
    "support.ticketMessage": "Your Message",
    "support.ticketCategory": "Category",
    "support.categoryGeneral": "General",
    "support.categoryTechnical": "Technical",
    "support.categoryBilling": "Billing",
    "support.categoryOther": "Other",
    "support.sendTicket": "SUBMIT",
    "support.ticketSent": "Your ticket has been submitted!",
    "support.ticketOpen": "Open",
    "support.ticketInProgress": "In Progress",
    "support.ticketResolved": "Resolved",
    "support.ticketClosed": "Closed",
    "support.priorityLow": "Low",
    "support.priorityMedium": "Medium",
    "support.priorityHigh": "High",
    "support.priorityUrgent": "Urgent",
    "support.replyPlaceholder": "Type your reply...",
    "support.sendReply": "REPLY",
    "support.telegramSupport": "Telegram Support",
    "support.telegramDesc": "Reach us on Telegram for quick support",
    "support.workingHours": "Working Hours",
    "support.responseTime": "Response Time",
    "support.adminTelegram": "Admin Telegram Accounts",
    
    // Announcements
    "announcements.title": "ANNOUNCEMENTS",
    "announcements.subtitle": "Important updates and information",
    "announcements.noAnnouncements": "No active announcements",
    "announcements.newAnnouncement": "NEW ANNOUNCEMENT",
    "announcements.editAnnouncement": "Edit Announcement",
    "announcements.announcementTitle": "Title",
    "announcements.announcementContent": "Content",
    "announcements.announcementType": "Type",
    "announcements.typeInfo": "Info",
    "announcements.typeWarning": "Warning",
    "announcements.typeSuccess": "Success",
    "announcements.typeError": "Error",
    "announcements.showOnDashboard": "Show on Dashboard",
    "announcements.expiresAt": "Expiration Date",
    "announcements.active": "Active",
    "announcements.inactive": "Inactive",
    
    // Admin Support
    "admin.tickets": "SUPPORT TICKETS",
    "admin.announcements": "ANNOUNCEMENTS",
    "admin.supportSettings": "Support Settings",
    "admin.telegramUsernames": "Telegram Usernames (Support)",
    "admin.telegramUsernamesHelp": "One username per line (without @)",
    "admin.supportEmail": "Support Email",
    "admin.workingHours": "Working Hours",
    "admin.responseTime": "Estimated Response Time",
  }
};

// Default features translations
export const featureTranslations = {
  tr: [
    { title: "YÜKSEK OTORİTE SİTELER", description: "DA 30+ sitelerden dofollow backlinkler ile domain otoritenizi artırın." },
    { title: "KREDİ SİSTEMİ", description: "Esnek kredi paketleri ile istediğiniz kadar backlink satın alın." },
    { title: "GÜVENLİ ÖDEME", description: "Kripto dahil tüm ödeme yöntemleri ile güvenli işlem yapın." },
    { title: "DOFOLLOW LİNKLER", description: "Tüm backlinklerimiz dofollow özelliğindedir ve SEO değeri taşır." },
    { title: "HIZLI İNDEXLEME", description: "Google'da hızlı indexlenme için optimize edilmiş link yapısı." },
    { title: "7/24 TEKNİK DESTEK", description: "Uzman ekibimiz her zaman yanınızda, sorularınıza anında cevap." }
  ],
  en: [
    { title: "HIGH AUTHORITY SITES", description: "Increase your domain authority with dofollow backlinks from DA 30+ sites." },
    { title: "CREDIT SYSTEM", description: "Buy as many backlinks as you want with flexible credit packages." },
    { title: "SECURE PAYMENT", description: "Secure transactions with all payment methods including crypto." },
    { title: "DOFOLLOW LINKS", description: "All our backlinks are dofollow and carry SEO value." },
    { title: "FAST INDEXING", description: "Optimized link structure for fast indexing on Google." },
    { title: "24/7 SUPPORT", description: "Our expert team is always with you, instant answers to your questions." }
  ]
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // Initialize from localStorage during state initialization
    const savedLang = localStorage.getItem("root-seo-language");
    return (savedLang === "tr" || savedLang === "en") ? savedLang : "tr";
  });

  // Update HTML lang attribute when language changes (for browser translation support)
  useEffect(() => {
    document.documentElement.lang = language;
  }, [language]);

  const changeLanguage = (lang) => {
    setLanguage(lang);
    localStorage.setItem("root-seo-language", lang);
    document.documentElement.lang = lang;
  };

  const t = (key) => {
    return translations[language][key] || key;
  };

  const getFeatures = () => {
    return featureTranslations[language];
  };

  return (
    <LanguageContext.Provider value={{ 
      language, 
      changeLanguage, 
      t,
      getFeatures,
      isEnglish: language === "en",
      isTurkish: language === "tr"
    }}>
      {children}
    </LanguageContext.Provider>
  );
};
